<template>
    <cw-modal :title="translate('suspicious_domain_user_activate_confirmation_title', user.email)" :id="store.modals.USERS_REVIEW_USER" size="md">
        <template v-slot>
            <div class="max-w-lg" v-html="translate('suspicious_domain_user_activate_confirmation_article', accountStore.avHtmlLink)"></div>

            <div class="mt-3 max-w-lg">
                {{translate("suspicious_domain_user_activate_confirmation_body", user.email, accountStore.companyName, accountStore.vat !== 0 ? accountStore.vat : "0")}}
            </div>

            <div class="mt-6 space-x-3">
                <a href="" class="btn btn-primary" v-on:click.prevent="accountStore.acceptUser(user)">{{ translate("suspicious_domain_user_activate_confirmation_ok") }}</a>
                <a class="btn btn-ghost" v-on:click.prevent="accountStore.rejectUser(user)" v-if="user.type !== 'deactivated'">{{ translate("suspicious_domain_user_activate_confirmation_cancel") }}</a>
            </div>
        </template>
    </cw-modal>
</template>

<script lang="ts">
import {defineComponent} from 'vue'
import {useAccountStore} from "../store";
import {User} from "./types";

export default defineComponent({
    name: "review-user-modal",
    props: {
        user: {
         type: Object as () => User,
         required: true
        }
    },
    data() {
        return {
            accountStore: useAccountStore()
        }
    }
})
</script>